export default __webpack_public_path__ + "2e410165838d6b48f4b700cbdd3f36a9.svg";